import { z } from 'zod'
import { childAgeCSVStringToNumberArray } from '~/utility/child-ages/child-ages'

export interface Party {
  adults: number
  childAges: number[]
  dogs?: number
}

export interface AllocationAlertPayloadCampsiteDetails {
  email: string
  arrive: string
  depart: string
  adults: string
  child_ages: string
  dogs?: string
  pitchtypesIds: string[]
  langCode: string
}

const userAllocationAlertCampsitePrimaryPhotoSchema = z.object({
  url: z.string(),
  caption: z.string(),
})
const userAllocationAlertDataSchema = z.object({
  adults: z.number(),
  arrive: z.string(),
  campsiteHierarchy: z.string(),
  campsiteName: z.string(),
  campsitePrimaryPhoto:
    userAllocationAlertCampsitePrimaryPhotoSchema.nullable(),
  campsiteSlug: z.string(),
  childAges: z.string().transform((v) => childAgeCSVStringToNumberArray(v)),
  depart: z.string(),
  dogs: z.number().optional().nullable(),
  hasAvailability: z.boolean(),
  id: z.string(),
  isFuture: z.boolean(),
  pitchtypes: z.array(z.string()),
  url: z.string(),
})
const userAllocationAlertSchema = z.object({
  data: userAllocationAlertDataSchema,
  type: z.literal('allocation_alert'),
})
export type UserAllocationAlertData = z.infer<
  typeof userAllocationAlertDataSchema
>

const categorySchema = z.object({
  id: z.number(),
  name: z.string(),
  rootSlug: z.string(),
  slug: z.string(),
})
const userLocationAllocationAlertDataSchema = z.object({
  adults: z.number(),
  arrive: z.string(),
  bounds: z
    .object({
      northEast: z.object({
        lat: z.number(),
        lng: z.number(),
      }),
      southWest: z.object({
        lat: z.number(),
        lng: z.number(),
      }),
    })
    .nullable()
    .optional(),
  categories: categorySchema.array(),
  categoryTexts: z.array(z.string()),
  childAges: z.string().transform((v) => childAgeCSVStringToNumberArray(v)),
  depart: z.string(),
  dogs: z.number().optional().nullable(),
  facetTexts: z.array(z.string()),
  hasAvailability: z.boolean(),
  id: z.string(),
  isFuture: z.boolean(),
  locationName: z.string(),
  nights: z.number(),
  party: z.string(),
  placePoint: z.string().nullable(),
  url: z.string(),
  withinDistance: z
    .object({
      mi: z.number(),
      km: z.number(),
    })
    .nullable(),
})
const userLocationAllocationAlertSchema = z.object({
  data: userLocationAllocationAlertDataSchema,
  type: z.literal('location_allocation_alert'),
})
export type UserLocationAllocationAlertData = z.infer<
  typeof userLocationAllocationAlertDataSchema
>

export const allocationAlertSchema = z.discriminatedUnion('type', [
  userAllocationAlertSchema,
  userLocationAllocationAlertSchema,
])

export type UserAllocationAlert = z.infer<typeof allocationAlertSchema>
